import React, { useState, useEffect } from 'react';
import { getConsentStatus, updateConsentStatus } from '../utils/consent';
import Icon from './Icon';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = getConsentStatus();
    const analyticsValue = consent === 'accepted' ? 'granted' : 'denied';

    if (!consent) {
      setIsVisible(true);
    }

    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('consent', 'update', { analytics_storage: analyticsValue });
    }
  }, []);

  const handleAccept = () => {
    updateConsentStatus('accepted');
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('consent', 'update', { analytics_storage: 'granted' });
    }
    setIsVisible(false);
  };

  const handleReject = () => {
    updateConsentStatus('rejected');
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('consent', 'update', { analytics_storage: 'denied' });
    }
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="cookie-consent-banner">
      <div className="cookie-consent-content">
        <div className="cookie-consent-text">
          <h3 className="cookie-consent-heading">
            <span className="cookie-consent-icon app-icon" aria-hidden="true">
              <Icon name="cookie" />
            </span>
            We use cookies
          </h3>
          <p>
            We use cookies to enhance your experience and collect anonymous analytics data 
            to improve our services. You can disable cookies in your browser settings at any time.
          </p>
        </div>
        <div className="cookie-consent-actions">
          <button 
            className="cookie-reject-btn" 
            onClick={handleReject}
          >
            Reject
          </button>
          <button 
            className="cookie-accept-btn" 
            onClick={handleAccept}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent; 
